export default __webpack_public_path__ + "static/media/settings.00c555e9.svg";